const ckTranslations = {
  de: {
    announcement: "Made in Germany",
    search_placeholder: "Produkte durchsuchen...",
    coming_soon_heading: "Cactus Knight öffnet bald für Sie",
    coming_soon_text: "Wir arbeiten mit Leidenschaft an unserem neuen Shop. Melden Sie sich für den Newsletter an und erfahren Sie als Erste/r, wenn wir live gehen.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Bleiben Sie auf dem Laufenden mit unseren neuesten Angeboten und Nachrichten.",
    footer_newsletter_placeholder: "Ihre E-Mail-Adresse",
    footer_support_heading: "Support",
    footer_account: "Mein Konto",
    footer_faq: "Häufige Fragen",
    footer_returns: "Retouren & Umtausch",
    footer_giftcards: "Gutscheinkarten",
    footer_info_heading: "Information",
    footer_about: "Über uns",
    footer_impressum: "Impressum",
    footer_widerruf: "Widerrufsrecht",
    footer_versand: "Zahlung & Versand",
    footer_datenschutz: "Datenschutzerklärung",
    footer_agb: "AGB",
    cookie_text: "Wir verwenden Cookies, um dir die bestmögliche Nutzung unserer Website zu ermöglichen. Einige sind technisch notwendig, andere helfen uns, die Website zu verbessern. Mehr dazu in unserer",
    cookie_privacy_link: "Datenschutzerklärung",
    cookie_accept: "Alle akzeptieren",
    cookie_decline: "Nur notwendige",
  },
  en: {
    announcement: "Made in Germany",
    search_placeholder: "Search products...",
    coming_soon_heading: "Cactus Knight opens soon",
    coming_soon_text: "We're working hard on our new shop. Sign up for our newsletter to be the first to know when we go live.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Stay up to date with our latest offers and news.",
    footer_newsletter_placeholder: "Your email address",
    footer_support_heading: "Support",
    footer_account: "My Account",
    footer_faq: "FAQ",
    footer_returns: "Returns & Exchanges",
    footer_giftcards: "Gift Cards",
    footer_info_heading: "Information",
    footer_about: "About us",
    footer_impressum: "Legal Notice",
    footer_widerruf: "Right of Withdrawal",
    footer_versand: "Payment & Shipping",
    footer_datenschutz: "Privacy Policy",
    footer_agb: "Terms & Conditions",
    cookie_text: "We use cookies to give you the best possible experience on our website. Some are technically necessary, others help us improve the website. More details in our",
    cookie_privacy_link: "Privacy Policy",
    cookie_accept: "Accept all",
    cookie_decline: "Necessary only",
  },
  es: {
    announcement: "Made in Germany",
    search_placeholder: "Buscar productos...",
    coming_soon_heading: "Cactus Knight abre pronto",
    coming_soon_text: "Estamos trabajando con dedicación en nuestra nueva tienda. Suscríbete a la newsletter para ser el primero en saberlo.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Manténte al día con nuestras últimas ofertas y novedades.",
    footer_newsletter_placeholder: "Tu dirección de correo electrónico",
    footer_support_heading: "Soporte",
    footer_account: "Mi cuenta",
    footer_faq: "Preguntas frecuentes",
    footer_returns: "Devoluciones y cambios",
    footer_giftcards: "Tarjetas regalo",
    footer_info_heading: "Información",
    footer_about: "Sobre nosotros",
    footer_impressum: "Aviso legal",
    footer_widerruf: "Derecho de desistimiento",
    footer_versand: "Pago y envío",
    footer_datenschutz: "Política de privacidad",
    footer_agb: "Términos y condiciones",
    cookie_text: "Utilizamos cookies para ofrecerte la mejor experiencia posible en nuestro sitio web. Algunas son técnicamente necesarias, otras nos ayudan a mejorar el sitio. Más información en nuestra",
    cookie_privacy_link: "Política de privacidad",
    cookie_accept: "Aceptar todo",
    cookie_decline: "Solo necesarias",
  },
  it: {
    announcement: "Made in Germany",
    search_placeholder: "Cerca prodotti...",
    coming_soon_heading: "Cactus Knight apre presto",
    coming_soon_text: "Stiamo lavorando con passione al nostro nuovo negozio. Iscriviti alla newsletter per essere il primo a saperlo.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Resta aggiornato sulle nostre ultime offerte e novità.",
    footer_newsletter_placeholder: "Il tuo indirizzo email",
    footer_support_heading: "Assistenza",
    footer_account: "Il mio account",
    footer_faq: "Domande frequenti",
    footer_returns: "Resi e cambi",
    footer_giftcards: "Carte regalo",
    footer_info_heading: "Informazioni",
    footer_about: "Chi siamo",
    footer_impressum: "Note legali",
    footer_widerruf: "Diritto di recesso",
    footer_versand: "Pagamento e spedizione",
    footer_datenschutz: "Informativa sulla privacy",
    footer_agb: "Termini e condizioni",
    cookie_text: "Utilizziamo i cookie per offrirti la migliore esperienza possibile sul nostro sito. Alcuni sono tecnicamente necessari, altri ci aiutano a migliorare il sito. Maggiori informazioni nella nostra",
    cookie_privacy_link: "Informativa sulla privacy",
    cookie_accept: "Accetta tutti",
    cookie_decline: "Solo necessari",
  },
  "pt-PT": {
    announcement: "Made in Germany",
    search_placeholder: "Pesquisar produtos...",
    coming_soon_heading: "A Cactus Knight abre em breve",
    coming_soon_text: "Estamos a trabalhar com dedicação na nossa nova loja. Subscreva a newsletter para ser o primeiro a saber.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Fique a par das nossas últimas ofertas e novidades.",
    footer_newsletter_placeholder: "O seu endereço de email",
    footer_support_heading: "Apoio ao cliente",
    footer_account: "A minha conta",
    footer_faq: "Perguntas frequentes",
    footer_returns: "Devoluções e trocas",
    footer_giftcards: "Cartões-presente",
    footer_info_heading: "Informação",
    footer_about: "Sobre nós",
    footer_impressum: "Aviso legal",
    footer_widerruf: "Direito de retratação",
    footer_versand: "Pagamento e envio",
    footer_datenschutz: "Política de privacidade",
    footer_agb: "Termos e condições",
    cookie_text: "Utilizamos cookies para lhe proporcionar a melhor experiência possível no nosso site. Alguns são tecnicamente necessários, outros ajudam-nos a melhorar o site. Mais informações na nossa",
    cookie_privacy_link: "Política de privacidade",
    cookie_accept: "Aceitar tudo",
    cookie_decline: "Apenas necessários",
  },
  nl: {
    announcement: "Made in Germany",
    search_placeholder: "Producten zoeken...",
    coming_soon_heading: "Cactus Knight opent binnenkort",
    coming_soon_text: "We werken met passie aan onze nieuwe winkel. Meld u aan voor de nieuwsbrief en wees de eerste die het weet.",
    footer_newsletter_heading: "Nieuwsbrief",
    footer_newsletter_text: "Blijf op de hoogte van onze nieuwste aanbiedingen en nieuws.",
    footer_newsletter_placeholder: "Uw e-mailadres",
    footer_support_heading: "Klantenservice",
    footer_account: "Mijn account",
    footer_faq: "Veelgestelde vragen",
    footer_returns: "Retourneren & Ruilen",
    footer_giftcards: "Cadeaubonnen",
    footer_info_heading: "Informatie",
    footer_about: "Over ons",
    footer_impressum: "Colofon",
    footer_widerruf: "Herroepingsrecht",
    footer_versand: "Betaling & Verzending",
    footer_datenschutz: "Privacybeleid",
    footer_agb: "Algemene voorwaarden",
    cookie_text: "Wij gebruiken cookies om u de best mogelijke ervaring op onze website te bieden. Sommige zijn technisch noodzakelijk, andere helpen ons de website te verbeteren. Meer informatie in ons",
    cookie_privacy_link: "Privacybeleid",
    cookie_accept: "Alles accepteren",
    cookie_decline: "Alleen noodzakelijke",
  },
  fr: {
    announcement: "Made in Germany",
    search_placeholder: "Rechercher des produits...",
    coming_soon_heading: "Cactus Knight ouvre bientôt",
    coming_soon_text: "Nous travaillons avec passion sur notre nouvelle boutique. Inscrivez-vous à la newsletter pour être averti en premier.",
    footer_newsletter_heading: "Newsletter",
    footer_newsletter_text: "Restez informé de nos dernières offres et actualités.",
    footer_newsletter_placeholder: "Votre adresse e-mail",
    footer_support_heading: "Assistance",
    footer_account: "Mon compte",
    footer_faq: "Questions fréquentes",
    footer_returns: "Retours & échanges",
    footer_giftcards: "Cartes cadeaux",
    footer_info_heading: "Informations",
    footer_about: "À propos",
    footer_impressum: "Mentions légales",
    footer_widerruf: "Droit de rétractation",
    footer_versand: "Paiement & livraison",
    footer_datenschutz: "Politique de confidentialité",
    footer_agb: "Conditions générales",
    cookie_text: "Nous utilisons des cookies pour vous offrir la meilleure expérience possible sur notre site. Certains sont techniquement nécessaires, d'autres nous aident à améliorer le site. Plus d'informations dans notre",
    cookie_privacy_link: "Politique de confidentialité",
    cookie_accept: "Tout accepter",
    cookie_decline: "Nécessaires uniquement",
  },
};

function ckGetLang() {
  return (window.CK_LOCALE && ckTranslations[window.CK_LOCALE]) ? window.CK_LOCALE : "de";
}

function ckApplyLang(lang) {
  const dict = ckTranslations[lang] || ckTranslations.de;

  document.querySelectorAll("[data-i18n]").forEach((el) => {
    const key = el.dataset.i18n;
    if (dict[key]) el.textContent = dict[key];
  });

  document.querySelectorAll("[data-i18n-placeholder]").forEach((el) => {
    const key = el.dataset.i18nPlaceholder;
    if (dict[key]) el.setAttribute("placeholder", dict[key]);
  });

  const currentLabel = document.getElementById("lang-switcher-current");
  if (currentLabel) currentLabel.textContent = lang.split("-")[0].toUpperCase();

  document.querySelectorAll(".lang-switcher__menu a").forEach((link) => {
    link.classList.toggle("is-selected", link.dataset.lang === lang);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  ckApplyLang(ckGetLang());

  const switcher = document.getElementById("lang-switcher");
  const btn = document.getElementById("lang-switcher-btn");
  const menu = document.getElementById("lang-switcher-menu");
  if (!switcher || !btn || !menu) return;

  function closeMenu() {
    menu.hidden = true;
    switcher.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
  }

  function openMenu() {
    menu.hidden = false;
    switcher.classList.add("is-open");
    btn.setAttribute("aria-expanded", "true");
  }

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    if (menu.hidden) openMenu();
    else closeMenu();
  });

  document.addEventListener("click", (e) => {
    if (!switcher.contains(e.target)) closeMenu();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenu();
  });
});
